import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'maplibre-gl/dist/maplibre-gl.css'
import './index.css'
import { App } from './App'
import { legalPageFor, PrivacyPage, TermsPage } from './components/LegalPages'
import { initSyncEngine } from './lib/sync'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const container = document.getElementById('root')
if (!container) {
  throw new Error('Datum bootstrap: #root is missing from index.html')
}

// Static legal routes (plan T6.1): served from the SPA fallback, rendered
// pre-auth with zero data fetching — the sync engine never starts here.
const legal = legalPageFor(window.location.pathname)
if (legal !== null) {
  createRoot(container).render(
    <StrictMode>{legal === 'privacy' ? <PrivacyPage /> : <TermsPage />}</StrictMode>,
  )
} else {
  initSyncEngine(queryClient)
  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  )
}
